import request from '@/utils/request'

export function getPlatformContactList(params = {}) {
  return request.get('/legal/admin/platform/contact', params)
}

export function getPlatformContactDetail(id) {
  const params = {}
  if (id != null && id !== '') params.id = id
  return request.get('/legal/admin/platform/contact/detail', params)
}

export function savePlatformContact(data) {
  return request.post('/legal/admin/platform/contact/save', data)
}
